import IntelliganceChapter from './IntelliganceChapter';
export default IntelliganceChapter;
